export default "__VITE_ASSET__plXKzKQV__"